/**
 * Event delegation for minicart interactions
 * This ensures event listeners work even after DOM updates
 */
(function() {
  if (window.minicartHandlersAttached) return;
  window.minicartHandlersAttached = true;
  // De vertalingen stonden als Liquid-filters in dit script toen het nog inline
  // in base-minicart.liquid leefde. Ze komen nu uit window.translations, dat
  // layout/theme.liquid rendert vóór dit uitgestelde bestand draait. Defensief
  // lezen: een ontbrekende sleutel mag niets laten klappen.
  var minicartTranslations = (window.translations && window.translations.cart) || {};
  var minicartMutationFallback = minicartTranslations.mutationError || '';

  function clearMinicartMutationError(container) {
    if (!container) return;
    container.querySelectorAll('.js-cart-mutation-error').forEach(function(error) {
      error.remove();
    });
  }

  function showMinicartMutationError(item, message) {
    clearMinicartMutationError(item);
    var error = document.createElement('small');
    error.className = 'js-cart-mutation-error text-danger d-block mt-1';
    error.setAttribute('role', 'alert');
    error.textContent = message;
    var content = item.querySelector('.cart-item__content') || item;
    content.appendChild(error);
  }

  function clearCrosssellAddedNotice(container) {
    var notice = container && container.querySelector('.js-cart-added-notice');
    if (notice) notice.remove();
  }
  function showCrosssellAddedNotice(section, syncFailed) {
    if (!section) return;
    clearCrosssellAddedNotice(section);
    var notice = document.createElement('div');
    notice.className = 'ui-notice ui-notice--info js-cart-added-notice mt-1';
    notice.setAttribute('role', 'status');
    var body = document.createElement('span');
    body.className = 'ui-notice__body';
    body.textContent = (syncFailed
      ? window.translations?.cart?.addedDetailsError || 'Toegevoegd, maar de winkelwagengegevens konden niet worden bijgewerkt. Controleer je winkelwagen.'
      : window.translations?.cart?.addedRefreshError || 'Toegevoegd, maar de winkelwagen kon niet worden getoond. Bekijk je winkelwagen.') + ' ';
    var link = document.createElement('a');
    link.href = window.Shopify.routes.root + 'cart';
    link.textContent = window.translations?.cart?.showCart || 'Toon winkelwagen';
    body.appendChild(link);
    notice.appendChild(body);
    section.appendChild(notice);
  }

  // DOM → winkelwagenvorm: de fan-out in cart-client werkt op winkelwagendata
  // en niet op elementen. We bouwen die vorm uit de regels die op dit moment in
  // de drawer staan — precies wat de oude code ook meenam.
  function renderedDrawerCart() {
    var items = [];
    document.querySelectorAll('.drawer-cart [data-line-item-key]').forEach(function(element) {
      var key = element.getAttribute('data-line-item-key');
      if (!key) return;

      var properties = {};
      var configurationId = element.getAttribute('data-configuration-id');
      if (configurationId) {
        properties[window.cartClient.CONFIGURATION_PROPERTY] = configurationId;
      }

      items.push({ key: key, properties: properties });
    });

    return { items: items };
  }

  function drawerLineElements(keys) {
    return keys
      .map(function(key) {
        return document.querySelector('.drawer-cart [data-line-item-key="' + key + '"]');
      })
      .filter(Boolean);
  }

  // Het aantal in de header komt uit het antwoord van de mutatie zelf; de losse
  // GET /cart.js die daar vroeger voor gedaan werd is vervallen.
  var cartChangedEvent = (window.cartClient && window.cartClient.CART_CHANGED_EVENT) || 'cart:changed';

  document.addEventListener(cartChangedEvent, function(event) {
    var cart = event.detail && event.detail.cart;
    if (!cart || typeof cart.item_count !== 'number') return;

    document.querySelectorAll('.js-cart-count').forEach(function(el) {
      el.textContent = cart.item_count;
    });
  });

  // "1 item", "2 items": de kop van de lade kiest het zelfstandig naamwoord bij het
  // aantal ernaast. Meerdere scripts schrijven dat aantal (app.js, find-my-pot.js, dit
  // bestand), dus het woord volgt het getal via één observer op de lade in plaats van
  // in elk van hen. Liquid rendert de drie meervoudsvormen die Shopify voor 1, 2 en 5
  // koos; Intl kiest er één.
  var countPluralRules = window.Intl && Intl.PluralRules
    ? new Intl.PluralRules(document.documentElement.lang || 'nl')
    : null;

  function syncCartCountNouns() {
    document.querySelectorAll('.js-cart-count-noun').forEach(function(noun) {
      var count = noun.parentElement && noun.parentElement.querySelector('.js-cart-count');
      var number = count ? parseInt(count.textContent, 10) : NaN;
      if (isNaN(number)) return;
      var category = countPluralRules ? countPluralRules.select(number) : (number === 1 ? 'one' : 'other');
      var text = category === 'one' ? noun.dataset.nounOne
        : category === 'few' ? noun.dataset.nounFew
        : noun.dataset.nounOther;
      if (text && noun.textContent !== text) noun.textContent = text;
    });
  }

  var drawerRoot = document.querySelector('.drawer-cart');
  if (drawerRoot && drawerRoot.parentElement && window.MutationObserver) {
    new MutationObserver(syncCartCountNouns).observe(drawerRoot.parentElement, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }
  syncCartCountNouns();

  async function rejectFailedCartMutation(response) {
    if (response.ok) return response;
    var body = {};
    try {
      body = await response.json();
    } catch (_) {}
    throw new Error(body && body.description ? body.description : minicartMutationFallback);
  }

  var shippingLabels = {
    free: minicartTranslations.shippingFree || '',
    fallback: minicartTranslations.shippingFallback || ''
  };

  function updateShippingLabel() {
    var valueEl = document.getElementById('shipping-value');
    var container = document.getElementById('minicart-shipping-estimate');
    if (!valueEl || !container) return;

    // shippingLabel komt uit cart-helpers.js, dat vóór dit bestand laadt. De
    // guard blijft staan: zonder hem levert een ontbrekend cart-helpers.js
    // "shippingLabel is not defined" in de console op.
    if (typeof window.shippingLabel !== 'function') return;
    var totalCents = parseInt(container.getAttribute('data-cart-total'), 10) || 0;
    var thresholdCents = parseInt(container.getAttribute('data-free-shipping-threshold'), 10);
    var label = window.shippingLabel(totalCents, isNaN(thresholdCents) ? Infinity : thresholdCents);

    valueEl.textContent = shippingLabels[label];
    // De kleur hoort bij de rij, niet bij een inline stijl: `sum--free` staat in
    // assets/cart-drawer.css en een inline `style` zou dat ontwerp overstemmen.
    container.classList.toggle('sum--free', label === 'free');
  }

  // Helper to get minicart URL for section refresh
  function getMinicartUrl() {
    return cartSectionUrl('base-minicart');
  }

  // --- Laadtoestand: melden gaat meteen, tonen wacht af ----------------------
  // Twee dingen die vroeger in één functie zaten. `aria-busy` hoort bij de hele
  // mutatie en gaat onvertraagd aan: een schermlezer moet ook horen dat er iets
  // gebeurt wanneer er visueel niets verschijnt. Wat je zíet — de regel dimt,
  // het aantal wordt een ring, het subtotaal dimt — is een uitgestelde
  // beslissing. De drempels staan in cart-client; het skelet over
  // `.drawer-content` is weg. Grijze balken legden precies weg wat de koper op
  // dat moment leest.
  //
  // `pendingBusyItems` / `pendingBusyGroups` overleven tot de verversing de
  // DOM wisselt. De uitgestelde `show` plakt `is-busy` / `is-pending` op die
  // nóg bestaande knopen; ná de wissel zijn het losse verwijzingen en is de
  // nieuwe markup al de uitkomst, dus daar hoort geen laadklasse meer op.

  var pendingBusyItems = [];
  var pendingBusyGroups = [];
  var UNDO_WINDOW_MS = 7000;
  var undoState = null;

  function setMinicartBusy(isBusy) {
    var minicart = document.querySelector('.drawer-cart');
    if (!minicart) return;

    if (isBusy) {
      minicart.setAttribute('aria-busy', 'true');
    } else {
      minicart.removeAttribute('aria-busy');
    }
  }

  function setMinicartVisualBusy(isVisible) {
    pendingBusyItems.forEach(function(item) {
      if (!item || !item.isConnected) return;
      item.classList.toggle('is-busy', isVisible);
      var qty = item.querySelector('.qty');
      if (qty) qty.classList.toggle('is-busy', isVisible);
    });
    pendingBusyGroups.forEach(function(group) {
      if (!group || !group.isConnected) return;
      group.classList.toggle('is-busy', isVisible);
    });

    var amount = document.querySelector('.drawer-cart .total__amount');
    if (amount) amount.classList.toggle('is-pending', isVisible);
  }

  var minicartSpinner = window.cartClient.createDeferredSpinner({
    show: function() { setMinicartVisualBusy(true); },
    hide: function() { setMinicartVisualBusy(false); }
  });

  // De globale ingang blijft wat hij was: één schakelaar voor de laadtoestand.
  // app.js, product-card.js en find-my-pot.js roepen
  // hem onveranderd aan en krijgen het uitstel er gratis bij. Zonder
  // `pendingBusyItems` dimt alleen het subtotaal: er is dan geen regel die
  // wijzigt, alleen een totaal dat nog niet zeker is.
  function setMinicartLoading(isLoading) {
    setMinicartBusy(isLoading);

    if (isLoading) {
      minicartSpinner.start();
    } else {
      minicartSpinner.stop();
    }
  }

  // --- Ongedaan maken -------------------------------------------------------
  // De verwijderde regels leven in `undoState`, niet in de DOM: de
  // innerHTML-wissel zou ze anders wissen. Na elke verversing zetten we de
  // balk terug zolang het venster loopt. Terughalen is één `POST /cart/add.js`
  // met de bewaarde variant en eigenschappen — plant en pot dus samen, met
  // hetzelfde `_configuration_id`. Shopify zet een teruggehaalde regel
  // onderaan; dat is bekend gedrag, geen bug. Sluiten van de lade stopt het
  // venster.

  function hideUndoBar() {
    var bar = document.querySelector('.drawer-cart .undo');
    if (bar) bar.hidden = true;
  }

  function clearUndo() {
    if (undoState && undoState.timer) clearTimeout(undoState.timer);
    undoState = null;
    hideUndoBar();
  }

  function restoreUndoBar() {
    var bar = document.querySelector('.drawer-cart .undo');
    if (!bar || !undoState) return;
    var text = bar.querySelector('.undo__text');
    var template = text && text.getAttribute('data-template');
    if (text && template) {
      text.textContent = template.replace(/__TITLE__/g, undoState.label);
    }
    bar.hidden = false;
  }

  function offerUndo(items, label) {
    clearUndo();
    undoState = {
      items: items,
      label: label,
      timer: setTimeout(function() {
        undoState = null;
        hideUndoBar();
      }, UNDO_WINDOW_MS)
    };
    restoreUndoBar();
  }

  async function snapshotCartItems(keys) {
    var res = await fetch(window.Shopify.routes.root + 'cart.js');
    await rejectFailedCartMutation(res);
    var cart = await res.json();
    var wanted = {};
    keys.forEach(function(key) { wanted[key] = true; });
    return (cart.items || []).filter(function(item) {
      return item && wanted[item.key];
    }).map(function(item) {
      var snapshot = {
        id: item.variant_id || item.id,
        quantity: item.quantity,
        properties: item.properties || {},
        title: item.product_title || item.title || ''
      };
      var sellingPlan = item.selling_plan_allocation &&
        item.selling_plan_allocation.selling_plan &&
        item.selling_plan_allocation.selling_plan.id;
      if (sellingPlan) snapshot.selling_plan = sellingPlan;
      return snapshot;
    });
  }

  // --- Plek vasthouden bij verversen ---------------------------------------
  // De verversing wisselt de volledige innerHTML van `.drawer-cart` om, dus de
  // scroller én het element dat focus had worden vernietigd. Vóór de wissel
  // leggen we vast wat er terug moet: de scrollpositie en een DOM-vrije
  // beschrijving van de focus ({ key, control }). Ná de wissel zetten we ze
  // terug. Welke regel focus krijgt is een beslissing van cart-client
  // (`resolveFocusTarget`); hier staat alleen het plaatsen.

  // De vertaling van het controlevocabulaire van cart-client naar de markup van
  // `snippets/block-cartitem.liquid`.
  var FOCUS_CONTROL_SELECTORS = {
    increase: '.js-cart-item-quantity button.is-plus',
    decrease: '.js-cart-item-quantity button.is-min',
    quantity: '.cart-item-quantity__input',
    delete: '.js-cart-item-quantity button.ui-icon-button--danger'
  };

  function minicartScroller() {
    var minicart = document.querySelector('.drawer-cart');
    return minicart ? minicart.querySelector('.drawer-content') : null;
  }

  function focusControlName(element) {
    if (element.closest(FOCUS_CONTROL_SELECTORS.increase)) return 'increase';
    if (element.closest(FOCUS_CONTROL_SELECTORS.decrease)) return 'decrease';
    if (element.closest(FOCUS_CONTROL_SELECTORS.quantity)) return 'quantity';

    // Alles wat we niet herkennen normaliseert cart-client naar `delete`; dat
    // is de minknop bij aantal 1, die de regel verwijdert.
    return 'delete';
  }

  // Alleen focus binnen de drawer telt. Stond de focus ergens anders (of op
  // `<body>`), dan zetten we hem na de verversing niet: focus afpakken van
  // iemand die hem nooit had is erger dan niets doen.
  function focusDescriptorFor(element) {
    if (!element || typeof element.closest !== 'function') return null;

    var line = element.closest('.drawer-cart [data-line-item-key]');
    if (!line) return null;

    var key = line.getAttribute('data-line-item-key');
    if (!key) return null;

    return { key: key, control: focusControlName(element) };
  }

  /**
   * Leg vast wat de verversing straks vernietigt.
   *
   * @param {Element} [focusElement] het element dat de focus hoort te houden.
   *   De aantalhandler zet zijn knop vóór de mutatie op `disabled`, en een
   *   uitgeschakelde knop verliest de focus — daarom geeft die handler de
   *   aangeklikte knop expliciet mee in plaats van op `document.activeElement`
   *   te vertrouwen.
   */
  function captureMinicartPlace(focusElement) {
    var scroller = minicartScroller();
    var element = focusElement || document.activeElement;

    return {
      scrollTop: scroller ? scroller.scrollTop : null,
      focus: focusDescriptorFor(element),
      cart: renderedDrawerCart()
    };
  }

  function focusElementForTarget(target) {
    var minicart = document.querySelector('.drawer-cart');
    if (!minicart || !target) return null;

    // `.js-minicart-close` staat twee keer in de drawer: in de header en op de
    // backdrop. De header is het zichtbare element en dus het focusdoel.
    if (target.type === 'close') {
      return minicart.querySelector('.drawer-header .js-minicart-close');
    }

    if (target.type !== 'line') return null;

    var line = minicart.querySelector('[data-line-item-key="' + target.key + '"]');
    if (!line) return null;

    // Aantalknoppen ontbreken op sommige configuratieregels
    // (`show_quantity_buttons` in block-cartitem.liquid). Dan is de
    // verwijderknop het dichtstbijzijnde element dat er wél altijd is.
    var selector = FOCUS_CONTROL_SELECTORS[target.control] || FOCUS_CONTROL_SELECTORS.delete;

    return line.querySelector(selector) || line.querySelector(FOCUS_CONTROL_SELECTORS.delete);
  }

  function restoreMinicartPlace(place) {
    if (!place) return;

    var scroller = minicartScroller();
    if (scroller && typeof place.scrollTop === 'number') {
      scroller.scrollTop = place.scrollTop;
    }

    if (!place.focus) return;

    // De nieuwe winkelwagen lezen we uit de zojuist gerenderde markup: dat is
    // dezelfde vorm als de oude en het werkt ook voor bellers die geen
    // mutatieantwoord hebben (greeting-card.js, de boekethandler).
    var target = window.cartClient.resolveFocusTarget(place.focus, renderedDrawerCart(), place.cart);
    var element = focusElementForTarget(target);
    if (element && typeof element.focus === 'function') element.focus();
  }

  // Both refresh owners restore the presentation state after replacing the drawer.
  function replaceMinicartContent(newContent, place) {
    var minicart = document.querySelector('.drawer-cart');
    if (!minicart || !newContent) throw new Error(minicartMutationFallback);
    var captured = place || captureMinicartPlace();
    minicart.innerHTML = newContent.innerHTML;
    updateShippingLabel();
    restoreUndoBar();
    restoreMinicartPlace(captured);
  }

  // Helper to refresh minicart content
  async function refreshMinicart(place) {
    // Zonder meegegeven momentopname leggen we hem hier vast. De scrollpositie
    // klopt dan nog steeds; een beller buiten de drawer levert simpelweg geen
    // focusbeschrijving op en dan verplaatsen we ook niets.
    const captured = place || captureMinicartPlace();
    setMinicartLoading(true);
    try {
      const minicartUrl = getMinicartUrl();
      const res = await fetch(minicartUrl);
      await rejectFailedCartMutation(res);
      const html = await res.text();
      const temp = document.createElement('div');
      temp.innerHTML = html;
      const newContent = temp.querySelector('.drawer-cart');
      replaceMinicartContent(newContent, captured);
    } finally {
      // De innerHTML-wissel hierboven vernietigt `is-busy` op de oude knopen.
      // Dit ruimt `aria-busy` op en haalt een dimming weg die de drempel nog
      // niet had gehaald — precies het snelle antwoord waar niets flitst.
      setMinicartLoading(false);
    }
  }

  // Expose refreshMinicart globally for other scripts (like greeting-card.js)
  window.refreshMinicart = refreshMinicart;
  window.captureMinicartPlace = captureMinicartPlace;
  window.replaceMinicartContent = replaceMinicartContent;
  window.setMinicartLoading = setMinicartLoading;
  window.updateMinicartShippingLabel = updateShippingLabel;

  updateShippingLabel();

  var drawerRoot = document.querySelector('.drawer-cart');
  if (drawerRoot && typeof MutationObserver === 'function') {
    var wasOpen = drawerRoot.classList.contains('is-open');
    new MutationObserver(function() {
      var isOpen = drawerRoot.classList.contains('is-open');
      if (wasOpen && !isOpen) clearUndo();
      wasOpen = isOpen;
    }).observe(drawerRoot, { attributes: true, attributeFilter: ['class'] });
  }

  // Listen for greeting card added event to refresh minicart
  window.addEventListener('greetingCardAdded', async function() {
    console.log('🎴 Greeting card added event received, refreshing minicart...');
    await refreshMinicart();
  });

  // --- Cross-sell: bevestiging vóór verversing, zonder race -----------------
  // De verversing gooit de cross-sell-lijst opnieuw op en vernietigt daarmee de
  // knop waar het groene vinkje op staat. Daarom blijft er een korte pauze
  // tussen de bevestiging en de verversing zitten — even lang als de
  // `setTimeout` die hier stond, zodat de koper niets anders voelt. Het verschil
  // is dat we er nu op wachten in plaats van hem ernaast te laten lopen.
  var CROSSSELL_CONFIRMATION_MS = 600;

  function wait(ms) {
    return new Promise(function(resolve) {
      setTimeout(resolve, ms);
    });
  }

  // Eén reeks per formulier. De knop staat tijdens de mutatie én de
  // bevestigingspauze op `disabled` — hij wordt alleen in de catch weer
  // ingeschakeld — maar dat dekt niet elk pad: een formulier zonder
  // `.xsell__add`, of een verzending met Enter, komt er langs.
  var crosssellFormsInFlight = new WeakSet();

  // Event delegation for crosssell add-to-cart forms.
  // Capture-fase + `stopImmediatePropagation()` blijven hier bewust staan, en
  // dit is géén overgebleven vangregel: `initRelatedAddToCart()` in `app.js`
  // bindt nog steeds een eigen submit-handler op elk `form.js-related-add-to-cart`
  // — óók op de formulieren in de drawer, en opnieuw na elke `window.updateCart`.
  // Die handler is buiten scope van deze PRD. Haal deze regel dus pas weg samen
  // met die binding, anders levert één klik twee `POST /cart/add.js` op.
  document.addEventListener('submit', async function(event) {
    const form = event.target;
    if (!form.classList.contains('js-related-add-to-cart')) return;
    if (!form.closest('.drawer-cart')) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (crosssellFormsInFlight.has(form)) return;
    crosssellFormsInFlight.add(form);

    const btn = form.querySelector('.xsell__add');
    const crosssellItem = form.closest('.xsell__item');
    const errorContainer = crosssellItem || form;
    clearMinicartMutationError(errorContainer);
    clearCrosssellAddedNotice(errorContainer);
    var addCommitted = false;

    // De knop houdt zijn maat: tekst/icoon blijven in de DOM (alleen
    // onzichtbaar) en de ring komt er via CSS overheen. InnerHTML vervangen
    // liet de knop krimpen en de voet springen.
    if (btn) {
      btn.classList.remove('is-success', 'is-error');
      window.FlorafyUI.setButtonPending(btn, true);
    }

    try {
      const addResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: new FormData(form)
      });
      await rejectFailedCartMutation(addResponse);
      addCommitted = true;

      const res = await fetch(window.Shopify.routes.root + 'cart.js');
      await rejectFailedCartMutation(res);
      const cart = await res.json();

      // Update cart count in header
      document.querySelectorAll('.js-cart-count').forEach(function(el) {
        el.textContent = cart.item_count;
        el.classList.add('header-main__cart--hasitems');
      });

      if (btn) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.classList.add('is-success');
      }

      // Even wachten zodat de bevestiging zichtbaar is, dán pas verversen. Beide
      // staan binnen deze `try`, dus een mislukte verversing landt in de catch
      // hieronder in plaats van in een losse timer te verdwijnen.
      await wait(CROSSSELL_CONFIRMATION_MS);
      // Ook verversen wanneer de koper de drawer tijdens de pauze sluit. Het
      // openen van de drawer is alleen een klasse (`toggleMiniCart` in app.js),
      // er zit geen verversing aan vast — sla je hem hier over, dan mist de
      // drawer het zojuist toegevoegde product totdat iets anders hem ververst,
      // en blijft de cross-sell hem aanbieden. `.drawer-cart` staat op elke
      // pagina (`layout/theme.liquid`), dus er is niets om in te verdwalen.
      await refreshMinicart();

    } catch (error) {
      if (addCommitted || error.cartMutationCommitted) {
        if (btn) {
          window.FlorafyUI.setButtonPending(btn, false);
          btn.classList.remove('is-error');
          btn.classList.add('is-success');
        }
        showCrosssellAddedNotice(errorContainer, error.preorderSyncFailed);
        return;
      }
      console.error('Error adding product to cart:', error);
      if (btn) {
        window.FlorafyUI.setButtonPending(btn, false);
        btn.classList.remove('is-success');
        btn.classList.add('is-error');
      }
      showMinicartMutationError(errorContainer, error.message || minicartMutationFallback);
    } finally {
      crosssellFormsInFlight.delete(form);
    }
  }, true);

  // Event delegation for quantity buttons in minicart - CONFIGURATION AWARE
  // When changing quantity, update ALL items in the same configuration (plant + pot + potting)
  // De vangregel `stopImmediatePropagation()` is hier weg: de gekopieerde
  // aantalhandlers in `app.js` en `find-my-pot.js` bestaan niet meer, dus er is
  // niets meer om tegen te houden. De capture-fase blijft staan zodat
  // `preventDefault()` vóór elke andere luisteraar valt.
  document.addEventListener('click', async function(event) {
    const button = event.target.closest('.drawer-cart .js-cart-item-quantity button');
    if (!button) return;

    event.preventDefault();
    if (button.disabled) return;

    const rootItem = button.closest('[data-line-item-key]');
    if (!rootItem) return;

    // Vastleggen vóór alles: hieronder wordt de knop op `disabled` gezet en
    // daarmee verliest hij de focus, dus `document.activeElement` is straks
    // niet meer de eerlijke bron.
    const place = captureMinicartPlace(button);

    const key = rootItem.getAttribute('data-line-item-key');
    const configurationId = rootItem.getAttribute('data-configuration-id');
    const input = rootItem.querySelector('.js-cart-item-quantity input');
    const currentQty = parseInt(input.value) || 1;
    const isPlus = button.classList.contains('is-plus');
    const newQty = isPlus ? currentQty + 1 : Math.max(0, currentQty - 1);

    // Check if this item can be adjusted independently within a configuration (pot or filling material)
    const isIndependentQuantityBtn = button.hasAttribute('data-independent-quantity') || button.hasAttribute('data-pot-quantity');

    // De compositie-fan-out staat in cart-client; hier blijft alleen de
    // vertaling van sleutels terug naar de regels in de drawer.
    const resolvedKeys = window.cartClient.resolveMutationKeys(renderedDrawerCart(), key, {
      independentQuantity: isIndependentQuantityBtn
    });
    var keys = resolvedKeys.length ? resolvedKeys : [key];
    var aggregated = rootItem.getAttribute('data-aggregated-keys');
    if (newQty === 0 && aggregated) {
      var extra = aggregated.split(',').map(function(part) { return part.trim(); }).filter(Boolean);
      if (extra.length) keys = extra;
    }
    const updateItems = drawerLineElements(keys);

    // Knoppen meteen uit, visueel dimmen pas ná de drempel in cart-client.
    pendingBusyItems = updateItems;
    pendingBusyGroups = [];
    updateItems.forEach(item => {
      clearMinicartMutationError(item);
      item.querySelectorAll('.js-cart-item-quantity button').forEach(btn => btn.disabled = true);
    });
    setMinicartLoading(true);

    // Build updates object for all items in the configuration
    const updates = {};
    keys.forEach(itemKey => {
      updates[itemKey] = newQty;
    });

    console.log(`🔄 Updating ${keys.length} item(s) in configuration ${configurationId || 'none'} to qty ${newQty}`);

    var didRefresh = false;
    try {
      var removedSnapshot = null;
      if (newQty === 0) {
        removedSnapshot = await snapshotCartItems(keys);
      }

      await window.cartClient.updateCart(updates, { fallbackErrorMessage: minicartMutationFallback });

      if (removedSnapshot && removedSnapshot.length) {
        var titleEl = rootItem.querySelector('.item__title');
        offerUndo(removedSnapshot, titleEl ? titleEl.textContent.trim() : (removedSnapshot[0].title || ''));
      }

      didRefresh = true;
      await refreshMinicart(place);
    } catch (err) {
      console.error('Cart update error:', err);
      if (!didRefresh) setMinicartLoading(false);
      updateItems.forEach(item => {
        item.classList.remove('is-busy');
        var qty = item.querySelector('.qty');
        if (qty) qty.classList.remove('is-busy');
        item.querySelectorAll('.js-cart-item-quantity button').forEach(btn => btn.disabled = false);
      });
      showMinicartMutationError(rootItem, err.message || minicartMutationFallback);
    }
  }, true);

  // Event delegation for minicart close
  document.addEventListener('click', function(event) {
    const closeBtn = event.target.closest('.js-minicart-close');
    if (!closeBtn) return;

    const minicart = document.querySelector('.drawer-cart');
    if (minicart) {
      minicart.classList.remove('is-open');
    }
  });

  // Bouquet: Verwijder hele boeket (alle line items met dat _BouquetID in één batch)
  document.addEventListener('click', async function(event) {
    const btn = event.target.closest('.js-remove-bouquet');
    if (!btn) return;
    event.preventDefault();

    const bouquetId = btn.dataset.bouquetId;
    if (!bouquetId || btn.disabled) return;

    const group = btn.closest('.group');
    clearMinicartMutationError(group || btn.parentElement);
    window.FlorafyUI.setButtonPending(btn, true);
    pendingBusyItems = [];
    pendingBusyGroups = group ? [group] : [];
    setMinicartLoading(true);

    var didRefreshBouquet = false;
    try {
      const cartRes = await fetch(window.Shopify.routes.root + 'cart.js');
      await rejectFailedCartMutation(cartRes);
      const cart = await cartRes.json();
      const updates = {};
      for (const item of cart.items) {
        if (item.properties && item.properties._BouquetID === bouquetId) {
          updates[item.key] = 0;
        }
      }
      if (Object.keys(updates).length === 0) {
        setMinicartLoading(false);
        return;
      }
      await window.cartClient.updateCart(updates, { fallbackErrorMessage: minicartMutationFallback });
      // Refresh the active cart surface without dropping the storefront locale.
      if (document.querySelector('.drawer-cart.is-open') || btn.closest('.drawer-cart')) {
        didRefreshBouquet = true;
        await refreshMinicart();
      } else if (window.refreshCartPage) {
        await window.refreshCartPage();
        setMinicartLoading(false);
      } else {
        window.location.assign(cartSectionUrl('page-cart').split('?')[0]);
      }
    } catch (err) {
      console.error('Bouquet remove error:', err);
      if (!didRefreshBouquet) setMinicartLoading(false);
      if (group) group.classList.remove('is-busy');
      showMinicartMutationError(group || btn.parentElement, err.message || minicartMutationFallback);
    } finally {
      window.FlorafyUI.setButtonPending(btn, false);
    }
  });

  // Bouquet: Bewerk → sla _BouquetID op in sessionStorage en navigeer naar builder
  document.addEventListener('click', function(event) {
    const btn = event.target.closest('.js-edit-bouquet');
    if (!btn) return;
    event.preventDefault();
    const bouquetId = btn.dataset.bouquetId;
    if (!bouquetId) return;
    try {
      sessionStorage.setItem('florafy_editing_bouquet', bouquetId);
    } catch (_) { /* private mode */ }
    window.location.href = '/pages/bouw-je-boeket';
  });

  document.addEventListener('click', async function(event) {
    var btn = event.target.closest('.drawer-cart .undo__btn');
    if (!btn) return;
    event.preventDefault();

    var snapshot = undoState && undoState.items;
    clearUndo();
    if (!snapshot || !snapshot.length) return;

    btn.disabled = true;
    setMinicartLoading(true);
    try {
      var addResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        // Ongedaan maken zet regels terug die er al waren: geen nieuw kaartje en geen
        // blokkade door een leeg kaartjesbericht op de pagina (greeting-card.js).
        _skipGreetingCardInterceptor: true,
        body: JSON.stringify({
          items: snapshot.map(function(item) {
            var payload = { id: item.id, quantity: item.quantity, properties: item.properties };
            if (item.selling_plan) payload.selling_plan = item.selling_plan;
            return payload;
          })
        })
      });
      await rejectFailedCartMutation(addResponse);
      await refreshMinicart();
    } catch (err) {
      console.error('Undo error:', err);
      setMinicartLoading(false);
      showMinicartMutationError(document.querySelector('.drawer-cart .cart__body'), err.message || minicartMutationFallback);
    }
  });

  // De afrekenknop is een link; hij houdt zijn maat doordat `is-loading` de
  // spans verbergt en de ring eroverheen tekent. InnerHTML vervangen laat de
  // voet springen op het moment dat de koper klikt.
  document.addEventListener('click', function(event) {
    var cta = event.target.closest('.drawer-cart .ui-panel__footer a.cta');
    if (!cta) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;
    // Alleen onze eigen pending-toestand telt als tweede klik. `aria-busy` zet
    // perceived-performance.js al in de capture-fase van deze zelfde klik;
    // daarop blokkeren hield elke eerste klik tegen en dus de hele checkout.
    if (!window.FlorafyUI.setButtonPending(cta, true)) event.preventDefault();
  });

  window.addEventListener('pageshow', function() {
    document.querySelectorAll('.drawer-cart .ui-panel__footer a.cta').forEach(function(cta) {
      window.FlorafyUI.setButtonPending(cta, false);
    });
  });
})();
